module.exports = __webpack_public_path__ + "static/og-image-40960011feb76a9dce790066936ac649.jpg";